import {Contact} from "./contact";
import {Rule} from "./rule";

export class Group {
  id: number;
  title: string;
  numbers: Array<Contact>;
  rules: Array<Rule>;


  constructor(id: number, title: string, numbers: Array<Contact>) {
    this.id = id;
    this.title = title;
    this.numbers = numbers;
  }
}
